import { useContext } from 'react';
import { Typography, Drawer, List, ListItem, Button, Divider, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { appUserContext } from 'helpers/services';
import UserMenu from './UserMenu';
import LocaleMenu from './LocaleMenu';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { MdExitToApp as LogoutIcon, MdChecklist as TicketIcon } from 'react-icons/md';
import { IoPeople as CustomerIcon } from 'react-icons/io5'


interface ISidebarProps {
    sidebarOpen: boolean

    closeSidebar: () => void
}

let Sidebar = ({ sidebarOpen, closeSidebar }: ISidebarProps) => {
    let { formatMessage } = useIntl();

    let appUserService = useContext(appUserContext);

    let logout = async () => {
        await appUserService.signOut();
    }

    return (
        <Drawer
            anchor="left"
            onClose={closeSidebar}
            open={sidebarOpen}
            variant="temporary"
        >
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="body1">MENU</Typography>
                </Grid>
                <Grid item xs={12}>
                    <List>
                        <ListItem disableGutters onClick={closeSidebar}>
                            <Button component={RouterLink} to={'/customer/tickets'}>
                                <TicketIcon />&nbsp;Tickets
                            </Button>
                        </ListItem>
                        {appUserService.currentUser?.customerClaims?.isAdmin === true &&
                            <ListItem disableGutters onClick={closeSidebar}>
                                <Button component={RouterLink} to="/customer/users">
                                    <CustomerIcon />&nbsp;{formatMessage({ id: LocalizationIds.Users })}
                                </Button>

                            </ListItem>
                        }
                        <Divider variant="fullWidth" />
                        <ListItem disableGutters onClick={closeSidebar}>
                            <Button color="inherit" onClick={logout}>
                                <LogoutIcon />&nbsp;Logout
                            </Button>
                        </ListItem>
                        <Divider variant="fullWidth" />
                        <ListItem disableGutters>
                            <LocaleMenu />
                        </ListItem>
                        <Divider variant="fullWidth" />
                        <ListItem disableGutters style={{ justifyContent: 'center' }}>
                            <UserMenu />
                        </ListItem>

                    </List>
                </Grid>
            </Grid>
        </Drawer>
    )
}

export default Sidebar;